<template>
  <div
    class="chart-library-ui-container"
    :class="{
      'chart-style-library-ui-container': isChartStyleMode,
      'chart-list-library-ui-container': !isChartStyleMode
    }"
    ref="chartLibraryUIContainer"
  >
    <div
      v-if="!isChartStyleMode && !chartLibraryGroups.length && savedChartsStore.isAttemptingToLoadChartLists"
      class="chart-library-loading-spinner"
    ><i class="fad fa-fw fa-spinner-third fa-spin fa-2x"></i></div>
    <p
      v-if="!isChartStyleMode && !chartLibraryGroups.length && !savedChartsStore.isAttemptingToLoadChartLists && !savedChartsStore.hasFailedToLoadChartLists"
      class="chart-library-chart-group-message"
    >
      <span>It looks like you haven't created any ChartLists&nbsp;yet!</span>
      <br />
      <br />
      <button
        type="button"
        class="sc3-button sc3-button-green"
        @click="launchCreateChartListModal()"
      >Create ChartList</button>
    </p>
    <p
      v-if="!isChartStyleMode && !chartLibraryGroups.length && !savedChartsStore.isAttemptingToLoadChartLists  && savedChartsStore.hasFailedToLoadChartLists"
      class="chart-library-chart-group-message"
    >
      <span class="chart-library-chart-group-message-small-note">Failed to load ChartLists.</span>
    </p>
    <div v-show="isChartStyleMode || chartLibraryGroups.length">
      <div class="chart-library-ui">
        <div class="chart-library-ui-left">
          <span class="chart-library-ui-component">
            <label
              :for="isChartStyleMode ? 'chart-library-chart-style-groups' : 'chart-library-chart-groups'"
              class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
            >SELECT LIBRARY</label>
            <br />
            <select
              v-model="currentChartLibraryGroupRecid"
              class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-full-width"
              :id="isChartStyleMode ? 'chart-library-chart-style-groups' : 'chart-library-chart-groups'"
            >
              <template
                v-for="chartLibraryOptionGroup in chartLibraryOptionGroups"
                :key="chartLibraryOptionGroup.optgroupId"
              >
                <template v-if="chartLibraryOptionGroup.optgroupTitle">
                  <optgroup
                    v-if="chartLibraryOptionGroup.optgroupItems.length"
                    :label="chartLibraryOptionGroup.optgroupTitle"
                  >
                    <option
                      v-for="chartLibraryGroup in chartLibraryOptionGroup.optgroupItems"
                      :key="chartLibraryGroup.recid"
                      :value="chartLibraryGroup.recid"
                    >{{ chartLibraryGroup.htmlSanitizedName ?? chartLibraryGroup.name }}</option>
                  </optgroup>
                </template>
                <template v-else>
                  <option
                    v-for="chartLibraryGroup in chartLibraryOptionGroup.optgroupItems"
                    :key="chartLibraryGroup.recid"
                    :value="chartLibraryGroup.recid"
                  >{{ chartLibraryGroup.htmlSanitizedName ?? chartLibraryGroup.name }}</option>
                </template>
              </template>
            </select>
          </span>
          <span class="chart-library-ui-component">
            <label class="sc3-form-label sc3-form-label-inline sc3-form-label-small">VIEW AS</label>
            <br />
            <label
              class="sc3-toggle-button sc3-toggle-button-first"
              :class="{
                'sc3-toggle-button-active': viewAsGridOrList === GRID,
                'sc3-toggle-button-right-adjacent-active': viewAsGridOrList === LIST
              }"
            >
              <input
                type="radio"
                v-model="viewAsGridOrList"
                :value="GRID"
              />
              Grid
            </label>
            <label
              class="sc3-toggle-button sc3-toggle-button-last"
              :class="{
                'sc3-toggle-button-active': viewAsGridOrList === LIST,
                'sc3-toggle-button-left-adjacent-active': viewAsGridOrList === GRID
              }"
            >
              <input
                type="radio"
                v-model="viewAsGridOrList"
                :value="LIST"
              />
              List
            </label>
          </span>
        </div>
        <span class="chart-library-ui-right">
          <span
            v-if="!isChartStyleMode"
            class="chart-library-ui-component chart-library-ui-checkbox-component"
          >
            <SCThreeCheckbox
              id="chart-library-ui-load-symbol-only-checkbox"
              label-text="Load Symbol Only"
              :checkbox-value="isLoadSymbolOnlyEnabled"
              @update:checkbox-value="setIsLoadSymbolOnlyEnabled"
              :is-small-font="true"
              :is-circle="true"
              :is-single-spaced="true"
              :is-lato-font="true"
            />
          </span>
          <span
            v-show="viewAsGridOrList === GRID"
            class="chart-library-ui-component"
          >
            <label class="sc3-form-label sc3-form-label-inline sc3-form-label-small">THUMBNAIL SIZE</label>
            <br />
            <Slider
              v-model:sliderValue="thumbnailSize"
              :slider-min="MIN_THUMBNAIL_VALUE"
              :slider-max="MAX_THUMBNAIL_VALUE"
              :slider-step="1"
            />
          </span>
          <!-- <span class="chart-library-ui-component">
            <label
              :for="isChartStyleMode ? 'chart-library-chart-style-sort-menu' : 'chart-library-chart-sort-menu'"
              class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
            >SORT BY</label>
            <br />
            <select
              class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-full-width"
              :id="isChartStyleMode ? 'chart-library-chart-style-sort-menu' : 'chart-library-chart-sort-menu'"
            >
              <option>Alphabetical</option>
              <option>Most Recently Used</option>
              <option>Most Recently Modified</option>
              <option>Date Created</option>
              <option>Period</option>
              <option>Chart Type</option>
              <option>Color Scheme</option>
            </select>
          </span> -->
          <span
            class="chart-library-ui-component"
          >
            <label
              :for="isChartStyleMode ? 'chart-library-chart-style-filter-input' : 'chart-library-chart-filter-input'"
              class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
            >SEARCH {{ isChartStyleMode ? 'CHARTSTYLE' : 'CHARTLIST' }} LIBRARY</label>
            <br />
            <input
              type="text"
              class="sc3-text-input sc3-text-input-inline sc3-text-input-full-width"
              :id="isChartStyleMode ? 'chart-library-chart-style-filter-input' : 'chart-library-chart-filter-input'"
              placeholder="Search"
              v-model="filterText"
              @keyup.enter="handleFilterTextEnterKeyUp()"
              @focus="handleFilterInputFocus()"
              @blur="handleFilterInputBlur()"
              ref="filterInput"
              autocomplete="off"
            />
            <span class="filter-suggestions" v-if="filterTextSuggestions.length > 0 && isFilterInputFocused">
              <button
                v-for="filterTextSuggestion in filterTextSuggestions"
                :key="filterTextSuggestion.title"
                type="button"
                :title="filterTextSuggestion.sanitizedTitle"
                class="filter-suggestion"
                @mousedown="selectFilterTextSuggestion(filterTextSuggestion.title)"
                v-sanitize-html="filterTextSuggestion.title"
              ></button>
            </span>
          </span>
          <br />
          <span
            v-for="filterTextEntry in filterTextEntries"
            :key="filterTextEntry"
            class="filter-text-entry"
          >
            <span v-sanitize-html="filterTextEntry"></span>
            &nbsp;
            <button
              type="button"
              title="Remove Filter"
              class="remove-filter-button"
              @click="removeFilterEntry(filterTextEntry)"
            ><i class="far fa-fw fa-times"></i></button>
          </span>
          <button
            v-if="filterTextEntries.length > 0"
            type="button"
            title="Remove All Filters"
            class="filter-text-entry-reset-button"
            @click="resetFilterTextEntries()"
          >Reset</button>
        </span>
      </div>
      <div
        v-if="!currentFilteredChartGroupThumbnailRows.length && (!currentChartLibraryGroup || currentChartLibraryGroup.isAttemptingToLoadCharts)"
        class="chart-library-loading-spinner"
      ><i class="fad fa-fw fa-spinner-third fa-spin fa-2x"></i></div>
      <p
        v-if="!currentFilteredChartGroupThumbnailRows.length && currentChartLibraryGroup && !currentChartLibraryGroup.isAttemptingToLoadCharts && !currentChartLibraryGroup.hasFailedToLoadCharts && !filterTextEntries.length"
        class="chart-library-chart-group-message"
      >
        <span v-if="isChartStyleMode">It looks like you haven't saved any ChartStyles&nbsp;yet!</span>
        <span v-if="!isChartStyleMode">It looks like this {{ areCurrentChartLibraryChartsReadonly ? 'read-only' : '' }} ChartList is&nbsp;empty!</span>
        <br />
        <br />
        <span v-if="isChartStyleMode" class="chart-library-chart-group-message-small-note">Save your favorite indicators, overlays and chart settings here to quickly return to them in the&nbsp;future.</span>
        <span v-if="!isChartStyleMode" class="chart-library-chart-group-message-small-note">Save and organize the charts you're watching with your own&nbsp;ChartLists.</span>
        <br v-if="isChartStyleMode || !areCurrentChartLibraryChartsReadonly" />
        <br v-if="isChartStyleMode || !areCurrentChartLibraryChartsReadonly" />
        <button
          v-if="isChartStyleMode"
          @click="launchSaveChartStyleModal()"
          type="button"
          class="sc3-button sc3-button-green"
        >Save ChartStyle</button>
        <a
          v-if="!isChartStyleMode && !areCurrentChartLibraryChartsReadonly"
          :href="`/def/servlet/Favorites.CServlet?obj=${chartCode},${currentChartLibraryGroup.listNum}&cmd=show&disp=c`"
          class="sc3-button sc3-button-green"
        >Add Symbols</a>
      </p>
      <p
        v-if="!currentFilteredChartGroupThumbnailRows.length && currentChartLibraryGroup && !currentChartLibraryGroup.isAttemptingToLoadCharts && !currentChartLibraryGroup.hasFailedToLoadCharts && filterTextEntries.length > 0"
        class="chart-library-chart-group-message"
      >
        <span v-if="isChartStyleMode" class="chart-library-chart-group-message-small-note">No ChartStyles matching your search entries were&nbsp;found.</span>
        <span v-if="!isChartStyleMode" class="chart-library-chart-group-message-small-note">No charts matching your search entries were&nbsp;found.</span>
      </p>
      <p
        v-if="!currentFilteredChartGroupThumbnailRows.length && currentChartLibraryGroup && !currentChartLibraryGroup.isAttemptingToLoadCharts  && currentChartLibraryGroup.hasFailedToLoadCharts"
        class="chart-library-chart-group-message"
      >
        <span v-if="isChartStyleMode" class="chart-library-chart-group-message-small-note">Failed to load ChartStyles.</span>
        <span v-if="!isChartStyleMode" class="chart-library-chart-group-message-small-note">Failed to load charts.</span>
      </p>
      <div
        v-show="viewAsGridOrList === GRID && currentFilteredChartGroupThumbnailRows.length"
        class="chart-thumbnail-grid"
        :class="{
          'unsaved-chart-thumbnail-grid': !areCurrentChartLibraryChartsSaved,
          'saved-chart-thumbnail-grid': areCurrentChartLibraryChartsSaved
        }"
      >
        <div
          v-for="(chartThumbnailRow, chartThumbnailRowIndex) in currentFilteredChartGroupThumbnailRows"
          :key="chartThumbnailRowIndex"
          class="chart-thumbnail-row"
          :class="{ 'chart-thumbnail-row-odd-index': chartThumbnailRowIndex % 2 === 1 }"
        >
          <span
            v-for="chartOrChartStyle in chartThumbnailRow"
            :key="chartOrChartStyle.recid"
            class="chart-thumbnail"
            :class="{
              'chart-thumbnail-info-displayed': chartOrChartStyle.recid === recidOfChartWithThumbnailInfoTextDisplayed,
              'loaded-chart-thumbnail': (
                (isChartStyleMode && chartOrChartStyle.recid === chartStore.recidOfChartStyleBeingViewedWithAllChangesSaved) ||
                (!isChartStyleMode && (
                  (!isLoadSymbolOnlyEnabled && chartOrChartStyle.recid === chartStore.recidOfChartBeingViewed) ||
                  (isLoadSymbolOnlyEnabled && chartOrChartStyle.recid === chartStore.recidOfLoadSymbolOnlyChartBeingViewed)
                ))
              )
            }"
            :style="chartThumbnailCSSStyles"
          >
            <ChartLibraryDynamicTitleInput
              :chart-or-chart-style="chartOrChartStyle"
              :is-chart-style-mode="isChartStyleMode"
              :is-read-only="!areCurrentChartLibraryChartsSaved || areCurrentChartLibraryChartsReadonly"
              @input-blur="setChartOrChartStyleName(chartOrChartStyle)"
            />
            <ChartLibraryImage
              :img-src="isChartStyleMode ? `${chartOrChartStyle.thumbnailUrl}&s=${chartStore.urlEncodedSymbol}` : chartOrChartStyle.thumbnailUrl"
              :img-alt="chartOrChartStyle.name"
              :intersection-observer-visible-element-ids="intersectionObserverVisibleElementIds"
              :observe-intersection="observeIntersection"
              :unobserve-intersection="unobserveIntersection"
            />
            <div class="chart-thumbnail-info">
              <div class="chart-thumbnail-info-hide-button-container">
                <button
                  type="button"
                  :title="isChartStyleMode ? 'Hide ChartStyle Information' : 'Hide Chart Information'"
                  class="chart-thumbnail-info-hide-button"
                  @click="hideChartThumbnailInfoText()"
                ><i class="fas fa-fw fa-times-circle"></i></button>
              </div>
              <p
                v-if="isChartStyleMode && ('description' in chartOrChartStyle)"
                v-sanitize-html="chartOrChartStyle.description"
              ></p>
              <p
                v-if="!isChartStyleMode && ('comments' in chartOrChartStyle)"
                v-sanitize-html="chartOrChartStyle.comments"
              ></p>
            </div>
            <span
              class="chart-thumbnail-action-buttons-container"
              :style="chartThumbnailActionButtonsContainerCSSStyles"
            >
              <button
                :title="isChartStyleMode ? 'Apply ChartStyle' : 'Load Chart'"
                class="load-button"
                :style="chartThumbnailLoadButtonCSSStyles"
                type="button"
                @click="loadLibraryChart(chartOrChartStyle)"
              ><i class="fas fa-fw fa-arrow-alt-from-bottom"></i></button>
              <span class="chart-thumbnail-action-buttons">
                <button
                  v-if="isChartStyleMode"
                  title="Set ChartStyle As Your Default"
                  class="chart-thumbnail-action-button star-button"
                  :class="{ 'star-button-filled': chartOrChartStyle.recid === savedChartsStore.recidOfDefaultChartStyle }"
                  :style="chartThumbnailActionButtonCSSStyles"
                  type="button"
                  @click="isSimpleFrontendChartStyle(chartOrChartStyle) ? setDefaultChartStyle(chartOrChartStyle) : undefined"
                ><i class="far fa-fw fa-star"></i></button>
                <button
                  :title="isChartStyleMode ? 'Delete ChartStyle' : 'Delete Chart'"
                  class="chart-thumbnail-action-button delete-button"
                  :style="chartThumbnailActionButtonCSSStyles"
                  type="button"
                  @click="deleteChartOrChartStyle(chartOrChartStyle)"
                  :disabled="areCurrentChartLibraryChartsReadonly"
                ><i class="fas fa-fw fa-trash-alt"></i></button>
                <button
                  v-if="
                    (isChartStyleMode && ('description' in chartOrChartStyle) && chartOrChartStyle.description) ||
                    (!isChartStyleMode && ('comments' in chartOrChartStyle) && chartOrChartStyle.comments)
                  "
                  :title="isChartStyleMode ? 'Display ChartStyle Information' : 'Display Chart Comments'"
                  class="chart-thumbnail-action-button info-button"
                  :style="chartThumbnailActionButtonCSSStyles"
                  type="button"
                  @click="displayChartThumbnailInfoText(chartOrChartStyle)"
                ><i class="fas fa-fw fa-info-circle"></i></button>
              </span>
            </span>
          </span>
        </div>
      </div>
      <div
        v-show="viewAsGridOrList === LIST &&  currentFilteredChartGroupThumbnailRows.length"
        class="chart-list-view"
        :class="{
          'unsaved-chart-list-view': !areCurrentChartLibraryChartsSaved,
          'saved-chart-list-view': areCurrentChartLibraryChartsSaved
        }"
      >
        <div class="chart-list-view-column">
          <div class="chart-list-view-container">
            <div
              v-for="(chartThumbnailRow, chartThumbnailRowIndex) in currentFilteredChartGroupThumbnailRows"
              :key="chartThumbnailRowIndex"
            >
              <div
                v-for="chartOrChartStyle in chartThumbnailRow"
                :key="chartOrChartStyle.recid"
                class="chart-list-view-chart"
                :class="{
                  'loaded-chart-list-view-chart': (
                    (isChartStyleMode && chartOrChartStyle.recid === chartStore.recidOfChartStyleBeingViewedWithAllChangesSaved) ||
                    (!isChartStyleMode && (
                      (!isLoadSymbolOnlyEnabled && chartOrChartStyle.recid === chartStore.recidOfChartBeingViewed) ||
                      (isLoadSymbolOnlyEnabled && chartOrChartStyle.recid === chartStore.recidOfLoadSymbolOnlyChartBeingViewed)
                    ))
                  ),
                  'previewed-chart-list-view-chart': chartBeingPreviewedInChartListView && chartBeingPreviewedInChartListView.recid === chartOrChartStyle.recid
                }"
              >
                <button
                  type="button"
                  :title="isChartStyleMode ? 'Preview ChartStyle' : 'Preview Chart'"
                  class="chart-list-view-chart-name"
                  @click="previewChartInListView(chartOrChartStyle)"
                  v-sanitize-html="chartOrChartStyle.name"
                ></button>
                <span class="chart-list-view-chart-action-buttons">
                  <button
                    type="button"
                    :title="isChartStyleMode ? 'Apply ChartStyle' : 'Load Chart'"
                    class="chart-list-view-chart-action-button load-button"
                    @click="loadLibraryChart(chartOrChartStyle)"
                  ><i class="fas fa-fw fa-arrow-alt-from-bottom"></i></button>
                  <button
                    type="button"
                    :title="isChartStyleMode ? 'Edit ChartStyle Name' : 'Edit Chart Name'"
                    class="chart-list-view-chart-action-button edit-button"
                    @click="editChartName(chartOrChartStyle)"
                    :disabled="areCurrentChartLibraryChartsReadonly"
                  ><i class="fas fa-fw fa-pencil-alt"></i></button>
                  <button
                    type="button"
                    :title="isChartStyleMode ? 'Delete ChartStyle' : 'Delete Chart'"
                    class="chart-list-view-chart-action-button delete-button"
                    @click="deleteChartOrChartStyle(chartOrChartStyle)"
                    :disabled="areCurrentChartLibraryChartsReadonly"
                  ><i class="fas fa-fw fa-trash-alt"></i></button>
                  <button
                    v-if="isChartStyleMode"
                    type="button"
                    title="Set ChartStyle As Your Default"
                    class="chart-list-view-chart-action-button star-button"
                    :class="{ 'star-button-filled': chartOrChartStyle.recid === savedChartsStore.recidOfDefaultChartStyle }"
                    @click="isSimpleFrontendChartStyle(chartOrChartStyle) ? setDefaultChartStyle(chartOrChartStyle) : undefined"
                  ><i class="far fa-fw fa-star"></i></button>
                  <button
                    type="button"
                    :title="isChartStyleMode ? 'Preview ChartStyle' : 'Preview Chart'"
                    class="chart-list-view-chart-action-button info-button"
                    @click="previewChartInListView(chartOrChartStyle)"
                  ><i class="fas fa-fw fa-info-circle"></i></button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="chart-list-view-column">
          <div class="chart-list-view-preview-container">
            <template v-if="chartBeingPreviewedInChartListView">
              <div
                class="chart-list-view-preview-name"
                :title="chartBeingPreviewedInChartListView.htmlSanitizedName"
                v-sanitize-html="chartBeingPreviewedInChartListView.name"
              ></div>
              <img
                class="chart-list-view-preview-image"
                :src="isChartStyleMode ? `${chartBeingPreviewedInChartListView.thumbnailUrl}&s=${chartStore.urlEncodedSymbol}` : chartBeingPreviewedInChartListView.thumbnailUrl"
                :alt="chartBeingPreviewedInChartListView.name"
              />
              <p
                v-if="isChartStyleMode && ('description' in chartBeingPreviewedInChartListView) && chartBeingPreviewedInChartListView.description"
                class="chart-list-view-preview-info"
                v-sanitize-html="chartBeingPreviewedInChartListView.description"
              ></p>
              <p
                v-if="!isChartStyleMode && ('comments' in chartBeingPreviewedInChartListView) && chartBeingPreviewedInChartListView.comments"
                class="chart-list-view-preview-info"
                v-sanitize-html="chartBeingPreviewedInChartListView.comments"
              ></p>
              <button
                type="button"
                class="sc3-button sc3-button-green"
                @click="loadLibraryChart(chartBeingPreviewedInChartListView)"
              >
                <i class="fas fa-fw fa-arrow-alt-from-bottom"></i>
                &nbsp;{{ isChartStyleMode ? 'Apply ChartStyle' : 'Load Chart' }}
              </button>
            </template>
            <template v-else>
              <p class="chart-list-view-preview-instructions"><i class="fas fa-fw fa-long-arrow-left"></i>&nbsp;&nbsp;Select a {{ isChartStyleMode ? 'ChartStyle' : 'chart' }} to preview</p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, reactive, toRefs, computed, watch, onMounted, onUnmounted } from 'vue';
  import { useChartStore } from '@/stores/chartStore';
  import { useSavedChartsStore } from '@/stores/savedChartsStore';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { useUniqueIds } from '@/composables/useUniqueIds';
  import { useChartNames } from '@/composables/useChartNames';
  import { useChartStyleNames } from '@/composables/useChartStyleNames';
  import { useLoadSymbolOnly } from '@/composables/useLoadSymbolOnly';
  import { useLoadChartsAndChartStyles } from '@/composables/useLoadChartsAndChartStyles';
  import { useLocalStorage } from '@/composables/useLocalStorage';
  import { useModes } from '@/composables/useModes';
  import { useModals } from '@/composables/useModals';
  import { loadChartsForChartList } from '@/composables/loadChartsForChartList';
  import { setDefaultChartStyle } from '@/composables/setDefaultChartStyle';
  import { INVALID_CHART_STYLE_RECID } from '@/composables/isValidChartStyleRecid';
  import { INVALID_CHART_RECID } from '@/composables/isValidChartRecid';
  import { sortObjectsClosure } from '@/utils/sortObjectsClosure';
  import { isValidNumber } from '@/utils/isValidNumber';
  import SCThreeCheckbox from '@/components/checkboxes/SCThreeCheckbox.vue';
  import ChartLibraryDynamicTitleInput from '@/components/custom-widgets/ChartLibraryDynamicTitleInput.vue';
  import ChartLibraryImage from '@/components/custom-widgets/ChartLibraryImage.vue';
  import Slider from '@/components/sliders/Slider.vue';
  import { stripHtmlFromString } from '@/plugins/vue-sanitize-html';
  import { MODE_SPECIFIC_UI_ID } from '@/enums/html-ids';
  import { SimpleFrontendChart } from '@/interfaces/chart';
  import { SimpleFrontendChartStyle, isSimpleFrontendChartStyle } from '@/interfaces/chartStyle';

  const chartStore = useChartStore();
  const savedChartsStore = useSavedChartsStore();
  const { isLoggedIn, chartCode } = useAuthentication();
  const { getNegativeUniqueId } = useUniqueIds();
  const { setChartName } = useChartNames();
  const { setChartStyleName } = useChartStyleNames();
  const { isLoadSymbolOnlyEnabled, setIsLoadSymbolOnlyEnabled } = useLoadSymbolOnly();
  const { loadSimpleFrontendChart, loadSimpleFrontendChartStyle } = useLoadChartsAndChartStyles();
  const { getLocalStorageData, setLocalStorageData } = useLocalStorage();
  const { CHART_STYLE_LIBRARY_MODE } = useModes();
  const {
    launchCreateAccountModal,
    launchSaveChartStyleModal,
    launchDeleteChartModal,
    launchDeleteChartStyleModal,
    launchEditChartNameModal,
    launchEditChartStyleNameModal,
    launchCreateChartListModal
  } = useModals();
  const props = defineProps<{
    modeId: string;
  }>();
  const { modeId } = toRefs(props);
  const filterInput = ref<HTMLInputElement>();
  const filterText = ref('');
  const isFilterInputFocused = ref(false);
  const MIN_LOAD_BUTTON_FONT_SIZE_PIXELS = 16;
  const MAX_LOAD_BUTTON_FONT_SIZE_PIXELS = 50;
  const MIN_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS = 11;
  const MAX_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS = 18;
  const currentChartLibraryGroupRecid = ref(0);
  const yourChartStylesGroupRecid = getNegativeUniqueId();
  const isChartStyleMode = computed<boolean>(() => {
    return modeId.value === CHART_STYLE_LIBRARY_MODE.id;
  });
  const GRID = 'grid';
  const LIST = 'list';
  const VIEW_AS_LIST_OR_GRID_LOCAL_STORAGE_KEY = isChartStyleMode.value ? 'sc3WorkbenchChartStyleLibraryViewAsListOrGrid' : 'sc3WorkbenchChartListLibraryViewAsListOrGrid';
  const viewAsGridOrListInitialValue = getLocalStorageData(VIEW_AS_LIST_OR_GRID_LOCAL_STORAGE_KEY, '') === LIST ? LIST : GRID;
  const viewAsGridOrList = ref(viewAsGridOrListInitialValue);
  const THUMBNAIL_SIZES = [
    { width: 160, height: 100 },
    { width: 200, height: 125 },
    { width: 240, height: 150 },
    { width: 280, height: 175 }
  ] as const;
  const MIN_THUMBNAIL_VALUE = 1;
  const MAX_THUMBNAIL_VALUE = THUMBNAIL_SIZES.length;
  const THUMBNAIL_SIZE_LOCAL_STORAGE_KEY = isChartStyleMode.value ? 'sc3WorkbenchChartStyleLibraryThumbnailSize' : 'sc3WorkbenchChartListLibraryThumbnailSize';
  const THUMBNAIL_SIZE_DEFAULT_VALUE = 4;
  const thumbnailSizeInitialStringValue = getLocalStorageData(THUMBNAIL_SIZE_LOCAL_STORAGE_KEY, THUMBNAIL_SIZE_DEFAULT_VALUE.toString());
  let thumbnailSizeInitialNumberValue = isValidNumber(thumbnailSizeInitialStringValue, { isRequiredToBeInteger: true }) ? Number(thumbnailSizeInitialStringValue) : THUMBNAIL_SIZE_DEFAULT_VALUE;
  thumbnailSizeInitialNumberValue = thumbnailSizeInitialNumberValue >= MIN_THUMBNAIL_VALUE && thumbnailSizeInitialNumberValue <= MAX_THUMBNAIL_VALUE ? thumbnailSizeInitialNumberValue : THUMBNAIL_SIZE_DEFAULT_VALUE;
  const thumbnailSize = ref(thumbnailSizeInitialNumberValue);
  const recidOfChartWithThumbnailInfoTextDisplayed = ref(isChartStyleMode.value ? INVALID_CHART_STYLE_RECID : INVALID_CHART_RECID);
  let hasAutoSelectedTheFirstChartLibraryGroup = false;
  let hasAutoSelectedTheSecondChartLibraryGroup = false;
  const shouldAutoSelectTheFirstChartLibraryGroup = true;
  const shouldAutoSelectTheSecondChartLibraryGroup = computed<boolean>(() => {
    return isChartStyleMode.value && !isLoggedIn.value;
  });
  const chartBeingPreviewedInChartListView = computed<SimpleFrontendChart | SimpleFrontendChartStyle | null>(() => {
    for (const chartLibraryGroup of chartLibraryGroups.value) {
      for (const chartOrChartStyle of chartLibraryGroup.charts) {
        if (
          (isChartStyleMode.value && chartOrChartStyle.recid === savedChartsStore.recidOfChartStyleBeingPreviewedInChartLibraryListView) ||
          (!isChartStyleMode.value && chartOrChartStyle.recid === savedChartsStore.recidOfChartBeingPreviewedInChartLibraryListView)
        ) {
          return chartOrChartStyle;
        }
      }
    }

    return null;
  });
  const trimmedFilterText = computed<string>(() => {
    return filterText.value.trim();
  });
  const filterTextEntries: string[] = reactive([]);
  interface ChartLibraryOptionGroupOptGroupItem<T> {
    name: string;
    recid: number;
    htmlSanitizedName?: string;
    areSavedCharts?: boolean;
    isReadonly?: boolean;
    listNum?: number;
    charts: T[];
    isAttemptingToLoadCharts?: boolean;
    hasFailedToLoadCharts?: boolean;
  }
  interface ChartLibraryOptionGroup<T> {
    optgroupTitle: string;
    optgroupId: number;
    optgroupItems: ChartLibraryOptionGroupOptGroupItem<T>[];
  }
  const chartStyleLibraryOptionGroups = computed<ChartLibraryOptionGroup<SimpleFrontendChartStyle>[]>(() => {
    return [
        {
          optgroupTitle: '',
          optgroupId: 0,
          optgroupItems: [
            {
              name: 'Your ChartStyles',
              recid: yourChartStylesGroupRecid,
              areSavedCharts: true,
              charts: savedChartsStore.chartStyles,
              isAttemptingToLoadCharts: savedChartsStore.isAttemptingToLoadChartStyles,
              hasFailedToLoadCharts: savedChartsStore.hasFailedToLoadChartStyles
            }
          ]
        },
        {
          optgroupTitle: 'SAMPLE CHARTS',
          optgroupId: 1,
          optgroupItems: savedChartsStore.sampleChartStyleGroups
        }
      ];
  });
  const chartListLibraryOptionGroups = computed<ChartLibraryOptionGroup<SimpleFrontendChart>[]>(() => {
    return [
      {
        optgroupTitle: '',
        optgroupId: 2,
        optgroupItems: savedChartsStore.chartLists.map((chartList) => {
          return {
            ...chartList,
            areSavedCharts: true
          };
        })
      }
    ];
  });
  const chartLibraryOptionGroups = computed<ChartLibraryOptionGroup<SimpleFrontendChartStyle>[] | ChartLibraryOptionGroup<SimpleFrontendChart>[]>(() => {
    return isChartStyleMode.value ? chartStyleLibraryOptionGroups.value : chartListLibraryOptionGroups.value;
  });
  const chartLibraryGroups = computed<ChartLibraryOptionGroupOptGroupItem<SimpleFrontendChartStyle | SimpleFrontendChart>[]>(() => {
    const chartLibraryGroupsArray: ChartLibraryOptionGroupOptGroupItem<SimpleFrontendChartStyle | SimpleFrontendChart>[] = [];

    for (const chartLibraryOptionGroup of chartLibraryOptionGroups.value) {
      chartLibraryGroupsArray.push(...chartLibraryOptionGroup.optgroupItems);
    }

    return chartLibraryGroupsArray;
  });
  const currentChartLibraryGroup = computed<ChartLibraryOptionGroupOptGroupItem<SimpleFrontendChartStyle | SimpleFrontendChart> | null>(() => {
    return chartLibraryGroups.value.find(chartLibraryGroup => chartLibraryGroup.recid === currentChartLibraryGroupRecid.value) ?? null;
  });
  const areCurrentChartLibraryChartsSaved = computed<boolean>(() => {
    if (!currentChartLibraryGroup.value) {
      return false;
    }

    return currentChartLibraryGroup.value.areSavedCharts ?? false;
  });
  const areCurrentChartLibraryChartsReadonly = computed<boolean>(() => {
    return !!currentChartLibraryGroup.value?.areSavedCharts && !!currentChartLibraryGroup.value.isReadonly;
  });
  const currentChartLibraryCharts = computed<(SimpleFrontendChart | SimpleFrontendChartStyle)[]>(() => {
    if (!currentChartLibraryGroup.value) {
      return [];
    }

    return currentChartLibraryGroup.value.charts;
  });
  const currentFilteredChartGroupThumbnailRows = computed<(SimpleFrontendChart | SimpleFrontendChartStyle)[][]>(() => {
    let filteredCharts = [ ...currentChartLibraryCharts.value ];

    for (const filterTextEntry of filterTextEntries) {
      if (filterTextEntry) {
        filteredCharts = filteredCharts.filter(filterClosure(filterTextEntry));
      }
    }

    let currentFilteredChartThumbnailRow: (SimpleFrontendChart | SimpleFrontendChartStyle)[] = [];
    const filteredChartThumbnailRows: (SimpleFrontendChart | SimpleFrontendChartStyle)[][] = [];

    for (let i = 0; i < filteredCharts.length; i++) {
      if (i % numChartThumbnailsInRow.value === 0) {
        currentFilteredChartThumbnailRow = [];

        filteredChartThumbnailRows.push(currentFilteredChartThumbnailRow);
      }

      currentFilteredChartThumbnailRow.push(filteredCharts[i]);
    }

    return filteredChartThumbnailRows;
  });
  interface FilterTextSuggestion {
    title: string;
    sanitizedTitle: string;
    occurrences: number;
  }
  const filterTextSuggestions = computed<FilterTextSuggestion[]>(() => {
    if (!trimmedFilterText.value) {
      return [];
    }

    const suggestions: FilterTextSuggestion[] = [];

    for (const chartThumbnailRow of currentFilteredChartGroupThumbnailRows.value) {
      for (const chartOrChartStyle of chartThumbnailRow) {
        for (const searchTag of chartOrChartStyle.searchTags) {
          if (!isSearchTagAMatchForFilterText(searchTag, trimmedFilterText.value)) {
            continue;
          }

          const formattedSearchTag = searchTag.trim().toLowerCase();

          if (filterTextEntries.find(t => t.toLowerCase() === formattedSearchTag)) {
            continue;
          }

          const suggestion = suggestions.find(s => s.title.trim().toLowerCase() === formattedSearchTag);

          if (suggestion) {
            suggestion.occurrences++;
            continue;
          }

          suggestions.push({
            title: searchTag,
            sanitizedTitle: stripHtmlFromString(searchTag),
            occurrences: 1
          });
        }
      }
    }

    suggestions.sort(sortObjectsClosure({
      propertyName: 'occurrences',
      order: 'descending'
    }));

    return suggestions;
  });
  const windowWidth = ref(window.innerWidth);
  const chartLibraryUIContainerWidth = ref(window.innerWidth);
  const numChartThumbnailsInRow = computed<number>(() => {
    const width = dimensionsOfEachIndividualChartThumbnail.value.width;
    return Math.max(1, Math.ceil((windowWidth.value / width) - 1));
  });
  const dimensionsOfEachIndividualChartThumbnail = computed(() => {
    return THUMBNAIL_SIZES[thumbnailSize.value - 1] ?? THUMBNAIL_SIZES[THUMBNAIL_SIZES.length - 1];
  });
  const chartThumbnailCSSStyles = computed(() => {
    const widthPercentageOfEachIndividualChartThumbnail = 100 / numChartThumbnailsInRow.value;

    return {
      height: `${dimensionsOfEachIndividualChartThumbnail.value.height}px`,
      width: `calc(${widthPercentageOfEachIndividualChartThumbnail}% - 8px)` // 8px is the margin-right + margin-left on the .chart-thumbnail
    };
  });
  const chartThumbnailActionButtonsContainerCSSStyles = computed(() => {
    return {
      'line-height': `${dimensionsOfEachIndividualChartThumbnail.value.height - 26 - 2 - 6}px` // 26px is the height margin-bottom of the .chart-thumbnail-name, 2px is the padding-top of the .chart-thumbnail, 6px is the padding-bottom of the .chart-thumbnail
    };
  });
  const thumbnailSizePercent = computed<number>(() => {
    const thumbnailSizePercent = (thumbnailSize.value - MIN_THUMBNAIL_VALUE) / (MAX_THUMBNAIL_VALUE - MIN_THUMBNAIL_VALUE);

    return Math.min(1, Math.max(0, thumbnailSizePercent));
  });
  const chartThumbnailLoadButtonCSSStyles = computed(() => {
    const totalPossibleExtraFontSize = MAX_LOAD_BUTTON_FONT_SIZE_PIXELS - MIN_LOAD_BUTTON_FONT_SIZE_PIXELS;
    let fontSize = MIN_LOAD_BUTTON_FONT_SIZE_PIXELS + (totalPossibleExtraFontSize * thumbnailSizePercent.value);
    fontSize = Math.round(fontSize);
    fontSize = Math.min(MAX_LOAD_BUTTON_FONT_SIZE_PIXELS, Math.max(MIN_LOAD_BUTTON_FONT_SIZE_PIXELS, fontSize));

    return {
      'font-size': `${fontSize}px`,
      height: `calc(100% - ${chartThumbnailActionButtonFontSize.value + 8}px)`, // 8px is the padding-top and padding-bottom on .chart-thumbnail-action-button
      'padding-top': `${chartThumbnailActionButtonFontSize.value + 8}px` // 8px is the padding-top and padding-bottom on .chart-thumbnail-action-button
    };
  });
  const chartThumbnailActionButtonFontSize = computed<number>(() => {
    const totalPossibleExtraFontSize = MAX_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS - MIN_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS;
    let fontSize = MIN_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS + (totalPossibleExtraFontSize * thumbnailSizePercent.value);
    fontSize = Math.round(fontSize);

    return Math.min(MAX_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS, Math.max(MIN_CHART_ACTION_BUTTON_FONT_SIZE_PIXELS, fontSize));
  });
  const chartThumbnailActionButtonCSSStyles = computed(() => {
    return { 'font-size': `${chartThumbnailActionButtonFontSize.value}px` };
  });
  const chartLibraryUIContainer = ref<HTMLDivElement>();
  interface IntersectionObserverVisibleElementIds {
    [key: string]: boolean;
  }
  const intersectionObserverVisibleElementIds = ref<IntersectionObserverVisibleElementIds>({});
  const intersectionObserverObject = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (
        !entry ||
        !(entry.target instanceof HTMLElement) ||
        !entry.target.dataset ||
        !entry.target.dataset.intersectionObserverElementId ||
        !isValidNumber(entry.target.dataset.intersectionObserverElementId, { isRequiredToBeInteger: true, isRequiredToBeGreaterThanZero: true })
      ) {
        continue;
      }

      const elementId = `${Number(entry.target.dataset.intersectionObserverElementId)}`;

      if (!entry.isIntersecting) {
        delete intersectionObserverVisibleElementIds.value[elementId];
        continue;
      }

      intersectionObserverVisibleElementIds.value[elementId] = true;
    }
  });

  function observeIntersection(element: HTMLElement): void {
    intersectionObserverObject.observe(element);
  }

  function unobserveIntersection(element: HTMLElement, elementId: string): void {
    delete intersectionObserverVisibleElementIds.value[elementId];

    intersectionObserverObject.unobserve(element);
  }

  function filterClosure(currentFilterText: string): (chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle) => boolean {
    return (chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle) => {
      for (const searchTag of chartOrChartStyle.searchTags) {
        if (isSearchTagAMatchForFilterText(searchTag, currentFilterText)) {
          return true;
        }
      }

      return false;
    };
  }

  function isSearchTagAMatchForFilterText(searchTag: string, currentFilterText: string): boolean {
    return searchTag.trim().toLowerCase().indexOf(currentFilterText.trim().toLowerCase()) > -1;
  }

  function handleWindowResize(): void {
    windowWidth.value = window.innerWidth;
    const modeSpecificUIElement = document.getElementById(MODE_SPECIFIC_UI_ID);

    if (modeSpecificUIElement) {
      chartLibraryUIContainerWidth.value = modeSpecificUIElement.getBoundingClientRect().width - 2; // 2px is the border-left-width + border-right-width on the .mode-specific-ui-inner
    }
  }

  function displayChartThumbnailInfoText(chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle): void {
    recidOfChartWithThumbnailInfoTextDisplayed.value = chartOrChartStyle.recid;
  }

  function hideChartThumbnailInfoText(): void {
    recidOfChartWithThumbnailInfoTextDisplayed.value = isChartStyleMode.value ? INVALID_CHART_STYLE_RECID : INVALID_CHART_RECID;
  }

  function handleFilterTextEnterKeyUp(): void {
    const trimmedFilterTextCopy = trimmedFilterText.value;
    filterText.value = '';

    filterInput.value?.blur();
    handleFilterInputBlur();

    if (!trimmedFilterTextCopy) {
      return;
    }

    const filterTextIndex = filterTextEntries.findIndex(t => t.toLowerCase() === trimmedFilterTextCopy.toLowerCase());

    if (filterTextIndex > -1) {
      filterTextEntries.splice(filterTextIndex, 1, trimmedFilterTextCopy);
      return;
    }

    filterTextEntries.push(trimmedFilterTextCopy);
  }

  function removeFilterEntry(filterTextEntry: string): void {
    const filterTextEntryIndex = filterTextEntries.findIndex(t => t.toLowerCase() === filterTextEntry.toLowerCase());

    if (filterTextEntryIndex > -1) {
      filterTextEntries.splice(filterTextEntryIndex, 1);
    }
  }

  function resetFilterTextEntries(): void {
    filterTextEntries.splice(0, filterTextEntries.length);
  }

  function handleFilterInputFocus(): void {
    isFilterInputFocused.value = true;
  }

  function handleFilterInputBlur(): void {
    isFilterInputFocused.value = false;
  }

  function selectFilterTextSuggestion(filterTextSuggestion: string): void {
    filterText.value = filterTextSuggestion;

    handleFilterTextEnterKeyUp();
  }

  async function loadLibraryChart(chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle): Promise<void> {
    if (
      !isLoggedIn.value &&
      chartOrChartStyle.isForPayingMembersOnly
    ) {
      launchCreateAccountModal();
      return;
    }

    previewChartInListView(chartOrChartStyle);

    if (isSimpleFrontendChartStyle(chartOrChartStyle)) {
      await loadSimpleFrontendChartStyle(chartOrChartStyle);
    } else {
      await loadSimpleFrontendChart(chartOrChartStyle);
    }
  }

  function previewChartInListView(chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle): void {
    if (isChartStyleMode.value) {
      savedChartsStore.$patch({ recidOfChartStyleBeingPreviewedInChartLibraryListView: chartOrChartStyle.recid });

      return;
    }

    savedChartsStore.$patch({ recidOfChartBeingPreviewedInChartLibraryListView: chartOrChartStyle.recid });
  }

  function editChartName(chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle): void {
    if (!isLoggedIn.value) {
      launchCreateAccountModal();
      return;
    }

    if (areCurrentChartLibraryChartsReadonly.value) {
      return;
    }

    if (isChartStyleMode.value) {
      launchEditChartStyleNameModal(chartOrChartStyle.recid);
      return;
    }

    launchEditChartNameModal(chartOrChartStyle.recid);
  }

  function deleteChartOrChartStyle(chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle): void {
    if (!isLoggedIn.value) {
      launchCreateAccountModal();
      return;
    }

    if (areCurrentChartLibraryChartsReadonly.value) {
      return;
    }

    if (isChartStyleMode.value) {
      launchDeleteChartStyleModal(chartOrChartStyle.recid);
      return;
    }

    launchDeleteChartModal(chartOrChartStyle.recid);
  }

  async function setChartOrChartStyleName(chartOrChartStyle: SimpleFrontendChart | SimpleFrontendChartStyle): Promise<void> {
    if (
      chartOrChartStyle.name === chartOrChartStyle.temporaryName ||
      areCurrentChartLibraryChartsReadonly.value
    ) {
      return;
    }

    if (isSimpleFrontendChartStyle(chartOrChartStyle)) {
      await setChartStyleName(chartOrChartStyle, chartOrChartStyle.temporaryName);
      return;
    }

    await setChartName(chartOrChartStyle, chartOrChartStyle.temporaryName);
  }

  function handleChartLibraryGroupsChanged(): void {
    if (
      shouldAutoSelectTheSecondChartLibraryGroup.value &&
      !hasAutoSelectedTheSecondChartLibraryGroup &&
      chartLibraryGroups.value[1]
    ) {
      currentChartLibraryGroupRecid.value = chartLibraryGroups.value[1].recid;
      hasAutoSelectedTheFirstChartLibraryGroup = true;
      hasAutoSelectedTheSecondChartLibraryGroup = true;
      return;
    }

    if (
      !shouldAutoSelectTheFirstChartLibraryGroup ||
      hasAutoSelectedTheFirstChartLibraryGroup ||
      !chartLibraryGroups.value[0]
    ) {
      return;
    }

    currentChartLibraryGroupRecid.value = chartLibraryGroups.value[0].recid;
    hasAutoSelectedTheFirstChartLibraryGroup = true;
  }

  async function handleCurrentChartLibraryGroupChanged(): Promise<void> {
    if (
      !currentChartLibraryGroup.value ||
      isChartStyleMode.value
    ) {
      return;
    }

    await loadChartsForChartList(currentChartLibraryGroup.value.recid, undefined, false);
  }

  async function handleViewAsGridOrListChanged() {
    setLocalStorageData(VIEW_AS_LIST_OR_GRID_LOCAL_STORAGE_KEY, viewAsGridOrList.value);
  }

  function handleThumbnailSizeChanged() {
    setLocalStorageData(THUMBNAIL_SIZE_LOCAL_STORAGE_KEY, thumbnailSize.value.toString());
  }

  watch(chartLibraryGroups, handleChartLibraryGroupsChanged);
  watch(currentChartLibraryGroup, handleCurrentChartLibraryGroupChanged);
  watch(viewAsGridOrList, handleViewAsGridOrListChanged);
  watch(thumbnailSize, handleThumbnailSizeChanged);

  onMounted(async () => {
    handleChartLibraryGroupsChanged();
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleWindowResize);
  });
</script>

<style scoped>
  .chart-library-ui-container {
    margin: 0px;
    padding: 0px;
  }

  .chart-library-ui {
    display: flex;
    justify-content: space-between;
    padding: 6px 10px 10px 10px;
    margin: 0px;
    font-size: 0px;
    width: 100%;
    border-bottom: 1px solid #c0ced8;
  }

  .chart-library-ui-left {
    height: fit-content;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .chart-library-ui-component {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    position: relative;
    margin: 0px;
  }

  .chart-library-ui-right {
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: end;
    gap: 8px;
  }

  .chart-library-ui-checkbox-component {
    height: 30px;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    vertical-align: bottom;
  }

  label.sc3-toggle-button {
    min-width: 74px;
    text-align: center;
  }

  .chart-library-loading-spinner,
  .chart-library-chart-group-message {
    font-size: 18px;
    text-align: center;
    font-weight: 700;
    margin: 0px;
    padding: 20px;
  }

  .chart-library-chart-group-message-small-note {
    font-size: 16px;
  }

  .chart-thumbnail-grid,
  .chart-list-view {
    padding: 0px;
    margin: 0px;
    width: 100%;
    overflow: visible;
    font-size: 0px;
  }

  .chart-list-view {
    padding: 6px;
  }

  .chart-list-view-column {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    height: 100%;
  }

  .chart-list-view-container,
  .chart-list-view-preview-container {
    padding: 4px 8px;
  }

  .chart-list-view-preview-container {
    background-color: #f2f5f7;
    border-radius: 5px;
    text-align: center;
    padding-top: 8px;
  }

  .chart-list-view-chart {
    border-radius: 5px;
  }

  .chart-list-view-chart:hover,
  .chart-list-view-chart.previewed-chart-list-view-chart {
    background-color: #e2e5e9;
  }

  .chart-list-view-chart.loaded-chart-list-view-chart {
    background-color: #c0ced8;
  }

  .chart-list-view-chart-name {
    font-size: 14px;
    font-weight: 700;
    border: none;
    background-color: transparent;
    padding: 8px;
    text-align: left;
  }

  .chart-list-view-chart-action-buttons {
    display: inline-block;
    text-align: right;
  }

  .chart-list-view-chart-action-button {
    width: 24px;
    border: none;
    padding: none;
    margin: none;
    background-color: transparent;
    display: none;
  }

  .chart-list-view-chart-name,
  .chart-list-view-chart-action-button {
    color: #4f5964;
  }

  .loaded-chart-list-view-chart .chart-list-view-chart-name,
  .loaded-chart-list-view-chart .chart-list-view-chart-action-button {
    color: black;
  }

  .chart-list-view-chart:hover .chart-list-view-chart-action-button,
  .chart-list-view-chart-action-buttons button.star-button-filled,
  .chart-list-view-chart-action-buttons button.info-button {
    display: inline-block;
  }

  .chart-list-view-preview-name {
    font-size: 18px;
    font-weight: 700;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chart-list-view-preview-image {
    display: inline-block;
    width: calc(100% - 60px);
  }

  .chart-list-view-preview-info {
    font-size: 14px;
    color: #707f8f;
  }

  .chart-list-view-preview-image,
  .chart-list-view-preview-info {
    margin: 0px 0px 14px 0px;
  }

  .chart-list-view-preview-instructions {
    font-size: 16px;
    font-weight: 700;
  }

  .chart-thumbnail-row {
    background-color: #f2f5f7;
  }

  .chart-thumbnail-row-odd-index {
    background-color: white;
  }

  .chart-thumbnail {
    display: inline-block;
    position: relative;
    padding: 2px 2px 6px 2px;
    margin: 4px;
    vertical-align: top;
    text-align: center;
  }

  .loaded-chart-thumbnail {
    outline: 4px solid #3281d0;
  }

  .chart-thumbnail-action-buttons-container {
    display: inline-block;
    position: absolute;
    left: 2px; /* 2px is the padding-left of the .chart-thumbnail */
    right: 2px; /* 2px is the padding-right of the .chart-thumbnail */
    bottom: 6px; /* 6px is the padding-bottom of the .chart-thumbnail */
    height: calc(100% - 34px);
    background-color: rgba(255, 255, 255, 0.75);
    z-index: 2;
    opacity: 0;
    transition: opacity 200ms ease-out;
  }

  .chart-thumbnail-action-buttons {
    display: inline-block;
    position: absolute;
    right: 0px;
    bottom: 0px;
    line-height: 1;
    padding: 0px 4px 0px 0px;
  }

  .chart-thumbnail-action-buttons-container:hover {
    opacity: 1;
  }

  .chart-thumbnail-info-displayed .chart-thumbnail-action-buttons-container {
    display: none;
    opacity: 0;
  }

  .chart-thumbnail-action-buttons-container .load-button {
    padding: 0px;
    border: none;
    color: #2c3e50;
    background-color: transparent;
    vertical-align: top;
    width: 100%;
  }

  .chart-thumbnail-action-buttons-container .load-button:hover {
    color: #1282f3;
  }

  .chart-thumbnail-action-button {
    height: 100%;
    border: none;
    background-color: transparent;
    padding: 4px;
    margin: 0px;
    line-height: 1;
  }

  .chart-list-view-chart-action-buttons button.load-button:hover {
    color: #1282f3;
  }

  .chart-thumbnail-action-buttons button.star-button:hover,
  .chart-thumbnail-action-buttons button.star-button-filled,
  .chart-list-view-chart-action-buttons button.star-button:hover,
  .chart-list-view-chart-action-buttons button.star-button-filled {
    color: #fa8238;
  }

  .chart-thumbnail-action-buttons button.edit-button:hover,
  .chart-list-view-chart-action-buttons button.edit-button:hover {
    color: #707f8f;
  }

  .chart-thumbnail-action-buttons button.delete-button:hover,
  .chart-list-view-chart-action-buttons button.delete-button:hover {
    color: #cc000e;
  }

  .chart-thumbnail-action-buttons button.info-button:hover,
  .chart-list-view-chart-action-buttons button.info-button:hover {
    color: #f9690e;
  }

  .chart-thumbnail-action-buttons button.star-button-filled i,
  .chart-list-view-chart-action-buttons button.star-button-filled i {
    font-weight: 900;
  }

  .unsaved-chart-thumbnail-grid .chart-thumbnail-action-buttons button.edit-button,
  .unsaved-chart-list-view .chart-list-view-chart-action-buttons button.edit-button,
  .unsaved-chart-thumbnail-grid .chart-thumbnail-action-buttons button.delete-button,
  .unsaved-chart-list-view .chart-list-view-chart-action-buttons button.delete-button,
  .unsaved-chart-thumbnail-grid .chart-thumbnail-action-buttons button.star-button,
  .unsaved-chart-list-view .chart-list-view-chart-action-buttons button.star-button {
    display: none;
  }

  .chart-style-library-ui-container .unsaved-chart-list-view .chart-list-view-chart-name {
    width: calc(100% - 48px); /* 48px is 2 * 24px, and 24px is the width of each .chart-list-view-chart-action-button of which there are 2 when viewing unsaved ChartStyles (there will eventually be 3 once we enable the save button) */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chart-style-library-ui-container .unsaved-chart-list-view .chart-list-view-chart-action-buttons {
    width: 48px; /* 48px is 2 * 24px, and 24px is the width of each .chart-list-view-chart-action-button of which there are 2 when viewing unsaved ChartStyles (there will eventually be 3 once we enable the save button) */
  }

  .chart-style-library-ui-container .saved-chart-list-view .chart-list-view-chart-name {
    width: calc(100% - 120px); /* 120px is 5 * 24px, and 24px is the width of each .chart-list-view-chart-action-button of which there are 5 when viewing saved ChartStyles */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chart-style-library-ui-container .saved-chart-list-view .chart-list-view-chart-action-buttons {
    width: 120px; /* 120px is 5 * 24px, and 24px is the width of each .chart-list-view-chart-action-button of which there are 5 when viewing saved ChartStyles */
  }

  .chart-list-library-ui-container .saved-chart-list-view .chart-list-view-chart-name {
    width: calc(100% - 96px); /* 96px is 4 * 24px, and 24px is the width of each .chart-list-view-chart-action-button of which there are 4 when viewing saved Charts */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chart-list-library-ui-container .saved-chart-list-view .chart-list-view-chart-action-buttons {
    width: 96px; /* 96px is 4 * 24px, and 24px is the width of each .chart-list-view-chart-action-button of which there are 4 when viewing saved Charts */
  }

  .chart-thumbnail-info {
    display: none;
    position: absolute;
    left: 2px; /* 2px is the padding-left of the .chart-thumbnail */
    right: 2px; /* 2px is the padding-right of the .chart-thumbnail */
    bottom: 6px; /* 6px is the padding-bottom of the .chart-thumbnail */
    height: calc(100% - 34px);
    background-color: rgba(255, 255, 255, 0.85);
    color: black;
    font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 700;
    text-align: center;
    padding: 6px;
    z-index: 1;
  }

  .chart-thumbnail-info p {
    font-size: 14px;
    padding: 14px 0px 0px 0px;
    margin: 0px;
    height: 100%;
    overflow: hidden;
  }

  .chart-thumbnail-info-displayed .chart-thumbnail-info {
    display: inline-block;
  }

  .chart-thumbnail-info-hide-button-container {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    text-align: right;
    padding: 4px;
  }

  .chart-thumbnail-info-hide-button {
    background-color: transparent;
    font-size: 16px;
    border: none;
    padding: 0px;
    margin: 0px;
    color: black;
    opacity: 0.75;
  }

  .chart-thumbnail-info-hide-button:hover,
  .chart-thumbnail-info-hide-button:active,
  .chart-thumbnail-info-hide-button:focus {
    opacity: 1;
  }

  .filter-text-entry {
    display: inline-block;
    vertical-align: top;
    background-color: #0f4d8a;
    padding: 4px 8px;
    margin: 4px 2px 0px 2px;
    border-radius: 3px;
    color: white;
    font-size: 12px;
    font-weight: 700;
  }

  .filter-text-entry-reset-button {
    display: inline-block;
    vertical-align: top;
    background-color: transparent;
    padding: 4px 8px;
    margin: 4px 2px 0px 2px;
    border: 1px solid #0f4d8a;
    border-radius: 3px;
    color: #0f4d8a;
    font-size: 12px;
    font-weight: 700;
    transition: all 0.35s ease;
    touch-action: manipulation;
    user-select: none;
  }

  .filter-text-entry-reset-button:hover,
  .filter-text-entry-reset-button:focus,
  .filter-text-entry-reset-button:active {
    background-color: #0f4d8a;
    border-color: #0f4d8a;
    color: white;
  }

  .remove-filter-button,
  .remove-filter-button:active,
  .remove-filter-button:focus {
    border: none;
    background-color: transparent;
    padding: 0px;
    margin: 0px;
    color: white;
  }

  .remove-filter-button:hover {
    color: #c0ced8;
  }

  .filter-suggestions {
    display: block;
    position: absolute;
    top: 48px;
    left: 0px;
    z-index: 1001;
    background-color: white;
    border: 2px solid #707f8f;
    border-radius: 4px;
  }

  .filter-suggestion,
  .filter-suggestion:active,
  .filter-suggestion:focus {
    display: block;
    font-size: 16px;
    font-weight: 700;
    color: #2d3339;
    padding: 3px 6px;
    width: 100%;
    border: none;
    background-color: transparent;
    text-align: left;
  }

  .filter-suggestion:hover {
    background-color: #c0ced8;
  }
</style>
